import { useCallback } from 'react';
import {
  trackAnalyticsEvent,
  EVENT_NAME,
  EventProps,
} from '@leagueplatform/analytics';
import {
  ANALYTICS_PRODUCT_AREA_NAMES,
  ANALYTICS_SCREEN_NAMES,
  SUB_PRODUCT_AREA_NAMES,
} from 'common/constants';

type ScreenName =
  (typeof ANALYTICS_SCREEN_NAMES)[keyof typeof ANALYTICS_SCREEN_NAMES];

export const useOnboardingAnalytics = (screenName: ScreenName) =>
  useCallback(
    (eventName: EVENT_NAME | string, props?: EventProps) => {
      trackAnalyticsEvent(eventName, {
        product_area: ANALYTICS_PRODUCT_AREA_NAMES.FOUNDATION,
        sub_product_area: SUB_PRODUCT_AREA_NAMES.ONBOARDING,
        screen_name: screenName,
        ...props,
      });
    },
    [screenName],
  );
